<template>
    <section class="card">
        <div class="flex gap-2">
            <h3 class="font-semibold">{{ descricao ? descricao : 'Formulário' }}</h3>
            <Status v-if="!resumoModulos" :status="statusResposta" />
        </div>
        <component v-for="(componente, id) in componentes" :key="id" :is="componente.chave" v-bind="componente"
            :identificador="id" :etapaComponente="etapaComponente" :idComponentePai="identificador" :localRealizacao="localRealizacao" :modulo="modulo" :resumo="resumo"/>
    </section>
</template>

<script>
import { defineComponent } from 'vue';
import PropsComponentesConstant from '@/constants/PropsComponentesConstant';
import OpcaoMultiplaEscolha from '@/common/OpcaoMultiplaEscolha.vue'
import OpcaoUnica from '@/common/OpcaoUnica.vue'
import Texto from '@/common/Texto.vue'
import TextoGrande from '@/common/TextoGrande.vue'
import Check from '@/common/Check.vue'
import Email from '@/common/Email.vue'
import Status from '@/components/Status.vue';
import ComponenteFormularioService from '@/services/componentes/ComponenteFormularioService'

/* eslint-disable vue/no-unused-components */
export default defineComponent({
    name: 'Formulario',
    components: {
        OpcaoMultiplaEscolha,
        OpcaoUnica,
        Texto,
        TextoGrande,
        Check,
        Email,
        Status
    },
    props: {
        ...PropsComponentesConstant.PROPS,
    },
    setup(props) {
        return ComponenteFormularioService.setup(props)
    }
});
</script>